import { Helmet, HelmetProvider } from "react-helmet-async";
import Navbar from "./Navbar";
import Footer from "./Footer";

const SITE_URL = "https://mbasolutions.co";
const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/Logo.webp`;

const Layout = ({
  title = "MBA Solutions - ISO Certification Provider",
  description = "MBA Solutions offers ISO certification services, helping businesses achieve compliance with international standards such as ISO 9001, ISO 14001, ISO 27001, and more. Get certified to improve quality, security, and efficiency.",
  keywords = "ISO certification, ISO 9001, ISO 14001, ISO 27001, ISO compliance, quality management, certification services, ISO consultants, MBA Solutions",
  author = "MBA Solutions",
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
  jsonLd,
  children,
}) => {
  const canonicalUrl = canonical || SITE_URL;

  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />
          <meta name="author" content={author} />
          <title>{title}</title>
          <link rel="canonical" href={canonicalUrl} />

          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:type" content={ogType} />
          <meta property="og:url" content={canonicalUrl} />
          <meta property="og:image" content={ogImage} />
          <meta property="og:site_name" content="MBA Solutions" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content={ogImage} />

          {jsonLd?.map((schema, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          ))}
        </Helmet>
        <Navbar />
        {children}
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Layout;
